export class ModuleRecomendationsTracking {
    // staff
    module;

    constructor() {
        this.init();
    }

    init() {
        this.module = $('.md-recommendations');

        if (!this.module.length) {
            return;
        }

        this.bindEvents();
    }

    bindEvents() {
        this.module.on('click', 'a.lnk', (e) => {
            const button = $(e.target);

            this.sendGTMEvent({
                bloque: this.getModuleTitleText(button),
                noticia: this.getText(button),
                event: 'recomendaciones'
            });
        });
    }

    sendGTMEvent(data) {
        if (window.dataLayer) {
            console.debug('Recomendations event track ', data);
            window.dataLayer.push(data);
        }
    }

    // auxiliary
    getModuleTitleText(button) {
        return button.closest('.md-recommendations').find('.m-title').text() || '';
    }

    getText(button) {
        return button.text() || '';
    }
}
